<template>
    <div>
        <a-card title="任务管理">
            <div slot="extra" class="topBtnBlock">
                <template v-if="C.Env != 'pro'">
                    <a-button v-if="is_list"  type="primary" @click="handleCompare()" >测试环境同步
                    </a-button>
                    <a-button v-else  type="default" @click="handleBack()" >返回
                    </a-button>
                </template>
                <div class="topBtnBlock" v-show="is_list">
                    <a-tooltip placement="top">
                        <template slot="title">
                            <span>beanid已存在的记录会被忽略</span>
                        </template>
                        <a-upload name="file" :multiple="true" action="https://032001.zhonglunnet.com"
                            :headers="headers" :data="handleImportFile" @change="handleChange">
                            <a-button type="primary" :loading="isImporting">
                                <a-icon type="upload" /> 导入 </a-button>
                        </a-upload>
                    </a-tooltip>

                    <a-button type="primary" @click="handleExportService('export_all')"  :loading="isExporting">导出全部
                    </a-button>
                    <a-button type="primary" @click="handleExportService('export_select')" :loading="isExporting">导出选中</a-button>
                    <a-button slot="extra" type="primary" @click="handleNewConfig">新增</a-button>
                </div>
            </div>
            <a-form layout="inline" @submit="handleSubmit" :form="form">
                <a-form-item label="执行器">
                    <a-select mode="default" v-model="searchP.jobGroup" style="width: 120px;" placeholder="请选择执行器"
                        show-search>
                        <a-select-option v-for="item in JobGroupList" :key="item.id">
                            {{ item.title }}
                        </a-select-option>
                    </a-select>
                </a-form-item>

                <a-form-item label="任务状态">
                    <a-select mode="default" v-model="searchP.triggerStatus" style="width: 80px;" placeholder="请选择任务状态"
                        show-search>
                        <a-select-option value="-1">
                            全部
                        </a-select-option>
                        <a-select-option value="0">
                            停止
                        </a-select-option>
                        <a-select-option value="1">
                            启动
                        </a-select-option>
                    </a-select>
                </a-form-item>

                <a-form-item label="版本">
                    <a-select mode="default" v-model="searchP.version" style="width: 80px;" placeholder="请选择版本"
                        show-search>
                        <a-select-option value="">
                            全部
                        </a-select-option>
                        <a-select-option value="V3.0">
                            V3.0
                        </a-select-option>
                        <a-select-option value="V5.0">
                            V5.0
                        </a-select-option>
                    </a-select>
                </a-form-item>

                <a-form-item label="任务标题">
                    <a-input v-model="searchP.jobDesc" style="width:120px" placeholder="请输入任务标题"></a-input>
                </a-form-item>

                <a-form-item label="servicekey">
                    <a-input v-model="searchP.executorParam" style="width:200px" placeholder="请输入servicekey"></a-input>
                </a-form-item>

                <a-form-item label="应用编码">
                    <AppAutoComplete ref="appcodeAs" @onAppCodeChange="handleSearchAppcodeChange"></AppAutoComplete>
                </a-form-item>

                <a-form-item label="负责人">
                    <a-input v-model="searchP.author" style="width:100px" placeholder="请输入负责人"></a-input>
                </a-form-item>

                <a-form-item>
                    <a-button type="primary" htmlType="submit" :key="this.loading.key">筛选</a-button>
                </a-form-item>
                <a-form-item>
                    <a-button type="default" htmlType="submit" :key="this.loading.key" @click="handleSearchReset">重置
                    </a-button>
                </a-form-item>
            </a-form>

            <div v-show="is_list">
                <!-- 系统列表 -->
                <a-table :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange ,type:rowsType}" :columns="columns" :data-source="list" :scroll="{ x: 800}" :pagination="false" :loading="tLoading" rowKey="id" style="margin-top:20px;" >
                    <a-tag :color="text == '1' ? '#87d068' : 'gray'" slot="triggerStatus" slot-scope="text">{{ text == '1' ? 'RUNNING' : 'STOP' }}</a-tag>
                    <template slot="operation" slot-scope="text, record">
                        <a-dropdown>
                            <a-button type="primary" @click="e => {e.preventDefault()}"> 操作 <a-icon type="down" /> </a-button>
                            <a-menu slot="overlay" @click="handleMenuClick($event,record)">
                                <a-menu-item key="job_trigger">
                                    执行一次 
                                </a-menu-item>
                                <a-menu-item key="job_info">
                                    查询日志
                                </a-menu-item>
                                <a-menu-item key="job_registryinfo">
                                注册节点
                                </a-menu-item>
                                <a-menu-item key="job_next_time" v-if="record.scheduleType == 'CRON' || record.scheduleType == 'FIX_RATE'">
                                下次执行时间
                                </a-menu-item>
                                <a-menu-item class="my_divider"></a-menu-item>

                                <a-menu-item key="job_stop" v-if="record.triggerStatus == 1">
                                停止
                                </a-menu-item>
                                <a-menu-item key="job_start" v-else>
                                启动
                                </a-menu-item>
                                <a-menu-item key="job_edit">
                                编辑
                                </a-menu-item>
                                <a-menu-item key="job_delete">
                                删除
                                </a-menu-item>
                                <a-menu-item key="job_copy">
                                复制
                                </a-menu-item>
                                
                            </a-menu>
                        </a-dropdown>
                    </template>
                    <template slot="jobGroups" slot-scope="text">
                        <span>{{JobGroupList.find(n => { return n.id == text }).title}}</span>
                    </template>
                </a-table>

                <a-pagination class="my_pagenation" v-model="searchP.page" :total="searchP.total" @change="handlePageChange" show-less-items show-quick-jumper />

                <zloprate ref="oprate_once"></zloprate>
                <edit ref="taskEditer" @onModalHide="handleModalHide"></edit>
                <!-- 注册节点弹框 -->

                <a-modal
                    title="注册节点"
                    v-model="registryVisible"
                    :footer="null"    
                    >
                    <p v-for="(item,index) in registryList" :key="index">
                        <span class="numbertext">{{index + 1}}.</span>
                        <span  class="bg-green">{{item}}</span>
                    </p>
                </a-modal>

                <a-modal
                    width="300px"
                    title="下次执行时间"
                    v-model="nexttimeVisible"
                    :footer="null"    
                    >
                    <p v-for="(item,index) in nexttimeList" :key="index" style="text-align:center;">
                        <span  class="bg-green">{{item}}</span>
                    </p>
                </a-modal>
            </div>
            <div v-show="!is_list">
                <compare ref="compareID"></compare>
            </div>
        </a-card>
    </div>
</template>

<script>
import zloprate from "./modals/oprate.vue";
import edit from "./modals/edit"
import AppAutoComplete from '@/components/AppAutoComplete'
import compare from "./modals/compare.vue"
const colums = [
    {
        title: "任务ID",
        width: 80,
        align: "center",
        dataIndex: 'id',
    },
    {
        title: '任务标题',
        dataIndex: 'jobDesc',
        align: 'center',
        width:200,
        ellipsis:true,
    },
    {
        title: '版本',
        dataIndex: 'version',
        align: 'center',
        width:100
    },
    {
        title: 'appCode',
        dataIndex: 'appCode',
        align: 'center',
        width:100
    },
    {
        title: 'V5版本-风控服务servicekey',
        dataIndex: 'executorParam',
        align: 'center',
        width:300,
        ellipsis:true,
    },
    {
        title: '调度类型',
        align: 'center',
        customRender: (text, record) => {
            if(record.scheduleConf){
                return record.scheduleType + ' : ' + record.scheduleConf
            }
            else{
                return record.scheduleType
            }
        },
        width:150
    },
    {
        title: '负责人',
        dataIndex: 'author',
        align: 'center',
        width:120,
        ellipsis: true
    },

    {
        title: '任务备注',
        dataIndex: 'jobRemark',
        align: 'center',
        width:120,
        ellipsis: true
    },
    {
        title: '状态',
        align: 'center',
        dataIndex: 'triggerStatus',
        scopedSlots: { customRender: 'triggerStatus' },
        width:120
    },
    {
        title: '操作',
        dataIndex: 'operation',
        width:100,
        align: 'center',
        scopedSlots: { customRender: 'operation' },
    }
                
];

export default {
    data() {
        return {
            is_list:true,
            form: this.$form.createForm(this),
            tLoading:false,
            searchP:{
                jobGroup:1,
                triggerStatus:'-1',
                version: '',
                jobDesc: '',
                appCode: '',
                executorParam: '',
                author: '',
                start: 0,
                page:1,
                length: 10,
                total:0,
                urlparams:false
            },

            ExecutorRouteStrategyEnum:[],//路由策略-列表
            GlueTypeEnum:[],//Glue类型-字典
            ExecutorBlockStrategyEnum:[],//阻塞处理策略-字典
            ScheduleTypeEnum:[],//调度类型
            MisfireStrategyEnum:[],//调度过期策略
            JobGroupList:[],//

            list:[],
            columns:colums,
            //注册节点的节点
            registryList:[],
            registryVisible:false,
            nexttimeVisible:false,
            nexttimeList:[],
            //导入导出
            isExporting:false,
            isImporting:false,
            headers: {
                authorization: 'authorization-text',
            },
            selectedRowKeys: [],
            rowsType: 'checkbox',
            checkStatuesTime:0,
        };
    },
    methods: {
        handleBack(){
            this.is_list = true;
        },
        handleCompare(){
            this.is_list = false;
            this.$refs.compareID.handleSearch(this.searchP)
        },
        handleModalHide(){
            this.getData();
        },
        //操作菜单点击
        handleMenuClick(e,record) {
            // e.preventDefault()

            let { href } = this.$router.resolve({ path: '/jobcenter/joblog',query:{jobId:record.id,jobGroup:record.jobGroup} })
            switch (e.key) {
                case 'job_trigger':
                    //执行一次
                    this.$refs.oprate_once.onModalInit(record);
                    break;
                case 'job_info':
                    //查询日志
                    window.open(href, '_blank')
                    break;
                case 'job_registryinfo':
                    //注册节点
                    this.handleRegistyinfo(record.jobGroup)
                    break;
                case 'job_next_time':
                    //下次执行时间
                    this.handleNexttime(record.scheduleType,record.scheduleConf)
                    break;
                case 'job_stop':
                    //停止
                    this.jobOprate('stop',record.id,'停止')
                    break;
                case 'job_start':
                    //启动
                    this.jobOprate('start',record.id,'启动')
                    break;
                case 'job_edit':
                    //编辑
                    this.$refs.taskEditer.onModalInit(record,this,'update')
                    break;
                case 'job_delete':
                    //删除
                    this.jobOprate('remove',record.id,'删除')
                    break;
                case 'job_copy':
                    //复制
                    this.$refs.taskEditer.onModalInit(record,this,'copy')
                    break;
                default:
                    break;
            }
            console.log(record)
        },
        //注册节点
        handleRegistyinfo(jobGroup){
            let that = this;
            that.$store.dispatch({
                type: 'jobcenter/loadById',
                params: {
                    id:jobGroup,
                    urlparams:false,
                }
            }).then((res) => {
                let result = res.data;
                if(result.code == 200){
                    that.registryList = result.content.registryList
                }
                else{
                    that.message.error(res.data.msg)
                }
                that.registryVisible = true;
            });
        },
        //下次执行时间
        handleNexttime(scheduleType,scheduleConf){
            let that = this;
            that.$store.dispatch({
                type: 'jobcenter/nextTriggerTime',
                params: {
                    scheduleType:scheduleType,
                    scheduleConf:scheduleConf,
                    urlparams:false,
                }
            }).then((res) => {
                if(res.data.code == 200){
                    that.nexttimeList = res.data.content
                }
                else{
                    that.message.error(res.data.msg)
                }
                that.nexttimeVisible = true;
            });
        },

        //任务 启动 停止 删除
        jobOprate(type,jobid,typename){
            console.log(type + ' ' + jobid)
            let that = this;
            this.$confirm({
                title: '系统提示',
                content: '确定'+typename+'任务?',
                onOk() {
                    that.$store.dispatch({
                        type: 'jobcenter/'+type,
                        params: {
                            id:jobid,
                            urlparams:false,
                        }
                    }).then((res) => {
                        if (res.data.code == 200) {
                            that.message.success('操作成功')
                            that.getData()
                        }
                        else{
                            that.message.error(res.data.msg || '操作失败')
                        }
                    });
                },
                onCancel() {
                    console.log('Cancel');
                },
            });
        },

        //新增配置
        handleNewConfig() {
            this.$refs.taskEditer.onModalInit('',this,'add')
        },

        handleSearchAppcodeChange(value) {
            this.searchP.appCode = value;
        },
        getEnum(){
            let that = this;
            that.$store.dispatch({
                type: 'jobcenter/queryEnum',
                params: {
                    urlparams:false,
                }
            }).then((res) => {
                let res1 = res.data;
                if(res1.success == 1){
                    let result = res1.data;
                    that.ExecutorRouteStrategyEnum = result.ExecutorRouteStrategyEnum;
                    that.GlueTypeEnum = result.GlueTypeEnum;
                    that.ExecutorBlockStrategyEnum = result.ExecutorBlockStrategyEnum;
                    that.ScheduleTypeEnum = result.ScheduleTypeEnum;
                    that.MisfireStrategyEnum = result.MisfireStrategyEnum;
                    that.JobGroupList = result.JobGroupList;
                    if(that.JobGroupList.length > 0){
                        that.searchP.jobGroup = that.JobGroupList[0].id
                    }
                    else{
                        that.searchP.jobGroup = ''
                    }
                    that.getData();
                }
            });
        },
        getData(){
            let that = this;
            that.tLoading = true;
            that.searchP.start = (that.searchP.page - 1) * that.searchP.length;
            that.$store.dispatch({
                type: 'jobcenter/queryjobcenter',
                params: that.searchP,
            }).then((res) => {
                let result = res.data;
                if(result.success == 1){
                    that.list = result.data.data;
                    that.searchP.total = result.data.recordsTotal;
                }
                that.tLoading = false;
            });
        },
        //筛选提交
        handleSubmit(e) {
            e && e.preventDefault();
            if(this.is_list){
                this.searchP.page = 1;
                this.getData()
            }
            else{
                console.log(1)
                this.$refs.compareID.handleSearch(this.searchP)
            }
        },
        // 分页事件
        handlePageChange(c){
            this.searchP.page = c;
            this.getData()
        },
        //筛选重置
        handleSearchReset() {
            this.searchP = {
                jobGroup:1,
                triggerStatus:'-1',
                version: '',
                jobDesc: '',
                appCode: '',
                executorParam: '',
                author: '',
                start: 0,
                page:1,
                length: 10,
                total:0,
                urlparams:false
            }
            this.getData();
        },
      
        //删除记录
        onRecordDelete(record){
            this.tLoading = true;
            this.$store.dispatch({
                type: '',
                params:{
                    id:record.id,
                    urlparams:false
                }
            }).then((res)=>{
                console.log(res);
                if(res.data.success == '1'){
                    this.message.success('删除成功！');
                }else{
                    this.message.error('删除失败');
                }
                this.getData();
            })
        },

        onSelectChange(selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys;
        },


        handleExportService(flag){
            let exportIds = this.selectedRowKeys.join(',')
            if (flag == 'export_select') {
                //导出选中
                if (!exportIds) {
                    this.message.error('请勾选需要导出的列')
                    return
                }
            } else {
                //导出所有
                if (exportIds) {
                    this.message.error('导出所有时，请不要选中列')
                    return
                }
            }

            let businesstype = "fpExportJobInfoConfig"
            this.isExporting = true
            this.$store
                .dispatch({
                    type: 'servicekey/exportService',
                    params: {
                        exportbusinesstype:businesstype,
                        exportparamsdesc:'{}',
                        exportids:exportIds,
                        urlparams:false
                    }
                })
                .then((res) => {
                    if(res.data.success == '1'){
                        console.log(res)
                        this.exportId = res.data.data
                        this.checkExportStatue();
                      
                    }
                    else{
                        this.isExporting = false;
                        this.message.error('导出失败')
                    }
                }).catch((e) => {
                    this.isExporting = false;
                    this.message.error('导出失败'+e.message)
                });
        },

        checkExportStatue(){
            if(this.checkStatuesTime > 3){
                this.message.error('超出请求次数')
                this.checkStatuesTime = 0;
                clearTimeout(this.timer)
                this.isExporting = false
                return;
            }
            let that = this;
            this.timer = setTimeout(function(){
                that.$store
                    .dispatch({
                        type: 'servicekey/checkExportStatue',
                        params: {id:that.exportId}
                    })
                    .then((res) => {
                        that.checkStatuesTime++
                        if(res.data.success == 1){
                            if(res.data.data.exportstatus == 1){
                                //导出成功
                                that.isExporting = false
                                let temp_File_Str = res.data.data.exportfilefull;
                                let files = temp_File_Str.split(',')
                                for (let index = 0; index < files.length; index++) {
                                    const element = files[index];
                                    window.open(element)
                                }
                                
                            }
                            else{
                                that.checkExportStatue()
                            }
                        }
                        else{
                            this.message.error(res.data.errorMsg)
                            that.checkExportStatue()
                        }
                    });
            },3000);
            
        },
        //上传文件结果处理
        handleChange(info) {
            if (info.file.status !== 'uploading') {
                console.log(info.file, info.fileList);
            }
            if (info.file.status === 'done') {
                this.saveImportRecord(info.file.objName,info.file.originFileObj.name);
                this.message.success(`${info.file.name} file uploaded successfully`);

            } else if (info.file.status === 'error') {
                this.message.error(`${info.file.name} file upload failed.`);
            }
        },
        getUniqueCode(){
            const s = [];
            const hexDigits = "0123456789abcdef";
            for (let i = 0; i < 36; i++) {
                s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
            }
            s[14] = "4";
            s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
            s[8] = s[13] = s[18] = s[23] = "-";
            return s.join("");
        },
        getSuffix(filename){
            const pos = filename.lastIndexOf('.');
            let suffix = '';
            if (pos !== -1) {
                suffix = filename.substring(pos)
            }
            return suffix;
        },
        handleImportFile(file){
            // let that = this;
            let result = this.D.syncSelect({
                type:'servicekey/importConfig',
                params:{}
            })
            if (result.success !== '1') {
                // that.message.error(result['errorMsg']);
                return false;
            }
            const data = result.data;
            const {
                dir,
                policy,
                accessid,
                callback,
                signature
            } = data;
            const token = {
                policy: policy,
                OSSAccessKeyId: accessid,
                success_action_status: '200',
                callback: callback,
                signature: signature
            };
            const objName = dir + this.getUniqueCode() + this.getSuffix(file.name);
            file.objName = objName;
            return{
                ...token,
                key: objName
            }

        },
        
        saveImportRecord(fileUrl,filename){
            let businesstype = "fpImportJobInfoConfig"
            this.isImporting = true;
            this.$store
                .dispatch({
                    type: 'servicekey/saveImportService',
                    params: {
                        importbusinesstype:businesstype,
                        shopcode:'125806668',
                        loginuserbranchcode:'1001',
                        sourcefile:fileUrl,
                        filename:filename,
                        syncstatus:1,
                        updownstatus:1,
                        urlparams:false
                    }
                })
                .then((res) => {
                    if(res.data.success == '1'){
                        console.log(res)
                        this.importId = res.data.data
                        this.checkImportStatue();
                        
                    }
                    else{
                        this.isImporting = false;
                        this.message.error('导入失败')
                    }
                    
                }).catch((e) => {
                    this.isImporting = false;
                    this.message.error('导入失败'+e.message)
                });
        },
    
        checkImportStatue(){
            if(this.checkStatuesTime > 3){
                this.message.error('超出请求次数')
                this.checkStatuesTime = 0;
                clearTimeout(this.timer)
                this.isImporting = false
                return;
            }
            let that = this;
            this.timer = setTimeout(function(){
                that.$store
                    .dispatch({
                        type: 'servicekey/checkImportStatue',
                        params: {id:that.importId}
                    })
                    .then((res) => {
                        if(res.data.success == 1){
                            if(res.data.data.importstatus == 1){
                            //导入成功
                                that.isImporting = false
                                //刷新页面
                                that.getData()
                            }
                            else if(res.data.data.importstatus == 2){
                                that.isImporting = false
                                that.message.error(res.data.data.errormsg)
                            }
                            else{
                                that.checkImportStatue()
                            }
                        }
                        else{
                            that.checkImportStatue()
                        }
                        console.log(res)
                        that.checkStatuesTime++
                    });
            },2000);
            
        },
    },

    components: {
        edit,
        zloprate,
        AppAutoComplete,
        compare
    },
    mounted() {
        this.getEnum();
    }
};

</script>

<style lang="less" scoped>
    .bg-green{
        color: white;
        background-color: #00a65a !important;
        padding: 2px 12px;
        border-radius: 2px;
    }

    .numbertext{
        font-weight: bold;
        padding: 2px 10px;
    }

    .my_divider{
        background-color: #eee;
        padding:0.5px;
    }

    .topBtnBlock{
        display: flex;
    }

    .topBtnBlock button{
        margin-right: 10px;
    }
</style>
